export default {
      id: "chevron-left-usage",
      viewBox: "0 0 15 26",
      url: "/" + "sprite.svg#chevron-left",
      toString: function () {
        return this.url;
      }
    }